// Google Calendar OAuth config — uses the same credentials as Gmail
// but with calendar-specific redirect URI and combined scopes
export const GOOGLE_CALENDAR_CONFIG = {
  clientId: import.meta.env.VITE_GMAIL_CLIENT_ID as string,
  clientSecret: import.meta.env.VITE_GMAIL_CLIENT_SECRET as string,
  redirectUri: `${window.location.origin}/settings/calendar/callback`,
  // SCOPE MINIMIZATION (2026-07-21). Removed: gmail.compose, gmail.modify,
  // gmail.readonly.
  //
  // NOTE: this scope array is currently DEAD CODE and is kept only so it does not
  // drift misleadingly out of sync. Both Google authorize URLs — SenderSettings.tsx
  // and CalendarSettings.tsx — send GMAIL_CONFIG.scope from src/lib/email/config.ts.
  // CalendarCallback.tsx imports GOOGLE_CALENDAR_CONFIG but reads only clientId /
  // clientSecret / redirectUri, never .scope. If you are changing what Google is
  // actually asked for, edit src/lib/email/config.ts — editing this file alone
  // changes nothing.
  //
  // Why: Google requires apps request scopes only for *implemented* features
  // ("We require that you only request scope access for implemented features" —
  // support.google.com/cloud/answer/13807380). We requested all three and used
  // none: the only Gmail API call in the codebase is users/me/messages/send
  // (useEmailProvider.ts, useEmailSender.ts, email-queue-processor sendViaGmail).
  //
  // Why it matters: gmail.readonly and gmail.modify are RESTRICTED scopes, which
  // trigger annual third-party CASA security assessment when restricted data is
  // stored or transmitted. gmail.send is merely "sensitive" — a lower tier with
  // no assessment. Carrying unused restricted scopes was pure liability.
  //
  // Verified safe: all 3 connected Gmail accounts were dormant at removal time
  // (0 sends in 90 days, 0 token-refresh failures, 2 of 3 never assigned a single
  // queue job). 100% of live sending is Outlook.
  //
  // BEFORE RE-ADDING ANY OF THESE: they are the wrong tool for bounce detection.
  // See docs/superpowers/specs/2026-07-21-hermes-deliverability-design.md §6.3 —
  // the chosen design polls Outlook via Graph Mail.Read (no CASA equivalent) and,
  // if Gmail bounce handling is ever needed, uses customer-configured forwarding
  // rather than a mailbox read. Re-adding a restricted scope re-arms CASA.
  //
  // NOT removed, both are load-bearing — do not "minimize" these:
  //   - calendar (full): calendar.events does NOT grant calendarList, which is
  //     used by CalendarCallback.tsx, EmailCallback.tsx, calendar-sync/index.ts.
  //   - Microsoft Mail.ReadWrite (see MICROSOFT_SCOPES below): powers the entire
  //     Outlook attachment/inline-image path in useEmailSender.ts (draft create,
  //     attachments, send). Mail.Send alone cannot do it.
  //
  // Existing grants are unaffected — connected accounts keep what they already
  // consented to until they reconnect. Deliberate: no forced re-consent. The
  // OAuth consent screen in Google Cloud Console must be updated separately.
  scope: [
    'https://www.googleapis.com/auth/gmail.send',
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/calendar',
    'https://www.googleapis.com/auth/calendar.events',
  ].join(' '),
};
